<template>
    <div>
        <FullPageLoader :isLoading="fullpageLoading"/>

        <b-modal :active.sync="invoiceExportModalOpen" id="invoiceexportmodal" aria-modal :width="800" scroll="keep" :can-cancel="true" style="overflow: initial">
            <header class="modal-card-head">
                <p class="modal-card-title">Transacties exporteren</p>
            </header>

            <section class="modal-card-body" :style="{ borderRadius: '0', overflow: exportType === 'snelstart' ? 'auto' : 'initial' }">
                <b-field label="Datumbereik (optioneel)">
                    <b-datepicker
                        placeholder="Klik om te selecteren"
                        v-model="dateRange"
                        :nearby-selectable-month-days="true"
                        :disabled="loading"
                        clearable
                        range
                    >
                        <b-button
                            label="Geen"
                            type="is-danger"
                            icon-left="times"
                            outlined
                            @click="dateRange = null"
                        />
                        <b-button
                            label="Huidige maand"
                            type="is-primary"
                            icon-left="calendar-alt"
                            outlined
                            @click="setDateRangeThisMonth"
                        />
                    </b-datepicker>
                </b-field>

                <br>

                <b-field label="Welke transacties wil je exporteren?"></b-field>
                <b-field class="paid">
                    <b-radio v-model="paid" :native-value="true" :disabled="loading">
                        Betaalde transacties
                    </b-radio>
                    <b-radio v-model="paid" :native-value="false" :disabled="loading">
                        Alle transacties
                    </b-radio>
                </b-field>

                <br>

                <b-field label="In welk format wil je de export maken?"></b-field>
                <b-field>
                    <b-select placeholder="Maak een keuze" v-model="exportType" expanded :disabled="loading">
                        <option value="planiteasy">Excel document (.xlsx)</option>
                        <option value="snelstart">SnelStart importbestand (.xlsx)</option>
                    </b-select>

                    <p class="control" v-if="exportType === 'snelstart'">
                        <a class="button is-primary" href="https://kennisplein.snelstart.nl/klanten/s/article/importeren-boekingen-importeren#deboekingenimporteren" target="_blank">
                            <span>Meer informatie</span>
                        </a>
                    </p>
                </b-field>

                <!-- SnelStart settings -->
                <slide-up-down :active="exportType === 'snelstart'" class="row">
                    <hr>
                    <h5>SnelStart velden</h5>

                    <div class="row">
                        <div class="column medium-6">
                            <b-field label="Dagboek (credit) *" v-if="type === 'recent'">
                                <b-input type="number" v-model="snelstart.fldDagboekCredit" :disabled="loading"></b-input>
                            </b-field>
                            <b-field label="Dagboek (debet)" v-else>
                                <b-input type="number" v-model="snelstart.fldDagboekDebet" :disabled="loading"></b-input>
                            </b-field>
                        </div>
                        <div class="column medium-6">
                            <b-field label="Grootboeknummer *">
                                <b-input type="number" v-model="snelstart.fldGrootboeknummer" :disabled="loading"></b-input>
                            </b-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="column medium-6">
                            <b-field label="Relatiecode *">
                                <b-input type="number" v-model="snelstart.fldRelatiecode" :disabled="loading"></b-input>
                            </b-field>
                        </div>
                    </div>
                </slide-up-down>
            </section>

            <footer class="modal-card-foot">
                <b-button type="is-light" @click="invoiceExportModalOpen = false" :disabled="loading">Sluiten</b-button>
                <b-button type="is-success" @click="makeExport" :disabled="loading || !canExport">Exporteren</b-button>
            </footer>
        </b-modal>
    </div>
</template>

<script>
import excelExportingMixin from '@/mixins/excelExportMixin'

export default {
    name: 'InvoiceExportModal',

    mixins: [excelExportingMixin],

    props: {
        passDateRange: {
            type: Array|null,
            default: null,
            required: false
        }
    },

    data() {
        return {
            loading: false,
            fullpageLoading: false,
            invoiceExportModalOpen: false,
            paid: true,
            exportType: 'planiteasy',
            excelExportType: 'invoices',
            dateRange: null,

            // SnelStart settings
            snelstart: {
                fldDagboekCredit: '',
                fldDagboekDebet: '',
                fldGrootboeknummer: '',
                fldRelatiecode: ''
            }
        }
    },

    computed: {
        user() {
            return this.$store.state.user
        },

        type() {
            return this.$route.params.type || this.$route.meta.type
        },

        canExport() {
            if (this.exportType === 'snelstart') {
                if (this.type === 'recent') {
                    return this.snelstart.fldDagboekCredit && this.snelstart.fldGrootboeknummer && this.snelstart.fldRelatiecode
                } else {
                    return this.snelstart.fldDagboekDebet && this.snelstart.fldGrootboeknummer && this.snelstart.fldRelatiecode
                }
            }

            return true
        }
    },

    created() {
        if (!this.passDateRange) {
            this.setDateRangeThisMonth()
        }
    },

    methods: {
        toggleExportModal() {
            if (this.passDateRange && this.passDateRange.length > 0) {
                this.dateRange = this.passDateRange
            }

            this.invoiceExportModalOpen = !this.invoiceExportModalOpen;
        },

        setDateRangeThisMonth(){
            // const thisMonth = [moment(new Date()).startOf('month')._d, moment(new Date()).endOf('month')._d]
            // this.$store.dispatch('setDateRange', thisMonth)
            this.dateRange = [moment(new Date()).startOf('month')._d, moment(new Date()).endOf('month')._d]
        },

        makeExport() {
            this.loading = true

            if (this.exportType === 'snelstart') {
                const newSettings = !_.isNull(this.user.settings) ? {...this.user.settings} : {}
                if (!_.has(newSettings, 'exports')) newSettings.exports = {} // add exports object if not exists
                newSettings.exports.snelstart = {...this.snelstart}

                axios.post('/api/user/save', {settings: newSettings}, {
                    headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
                }).then((response) => {
                    this.$store.dispatch('saveUserSettings', response.data)

                    this.loading = false
                })
            }

            this.$store.commit('startExport', true)
        }
    },

    watch: {
        exportType(newVal) {
            // Set SnelStart settings if available
            if (newVal === 'snelstart') {
                if (_.has(this.user, 'settings.exports.snelstart')){
                    this.snelstart = this.user.settings.exports.snelstart
                }
            }
        }
    }
}
</script>

<style lang="scss">
    #invoiceexportmodal {
        .modal-content{overflow: inherit;}
    }
</style>